import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import {
  Edit,
  Delete,
} from '@material-ui/icons/';
import { withRouter } from "react-router";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import MuiAlert from "@material-ui/lab/Alert";

import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  accountInfo: {
    display: "inline-box",
    width: "120px",
  },
  table: {
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  buttonCol: {
    textAlign: "center",
    width: "170px",
  },
  buttonRed: {
    color: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgba(220, 0, 78, 0.04)",
    },
  },
  alert: {
    marginTop: theme.spacing(2),
  },
}));

function Groups(props) {
  const { params } = props.match;
  const accountId = parseInt(params.accountId, 10);

  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [accountName, setAccountName] = React.useState("");
  const [groups, setGroups] = React.useState([]);
  const [isShowModal, setIsShowModal] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);
  const [success, setSuccess] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(null);


  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - アカウント詳細";

    if (props.location.search.indexOf("create") > -1) {
      setSuccess(true);
      setSuccessMessage("登録が完了しました");
    }
    if (props.location.search.indexOf("edit") > -1) {
      setSuccess(true);
      setSuccessMessage("更新が完了しました");
    }
    if (props.location.search.indexOf("delete") > -1) {
      setSuccess(true);
      setSuccessMessage("削除が完了しました");
    }
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchAccount();
    fetchGroups();
  }, [auth.state.token]);

  const fetchAccount = () => {
    request({
      method: "GET",
      url: `admin/accounts/${accountId}`,
    }).then((result) => {
      setAccountName(result.data.data.name);
    });
  }

  const fetchGroups = () => {
    request({
      method: "GET",
      url: `admin/media/${accountId}/groups`,
    }).then((result) => {
      setGroups(result.data.data);
    });
  };

  const onClickEditButton = (groupId) => {
    props.history.push(`/admin/media/accounts/group/${accountId}/edit/${groupId}`);
  };

  const openDialog = (id, date) => {
    setDeleteId(id);
    setIsShowModal(true);
  };

  const deleteGroup = () => {
    request({
      method: "DELETE",
      url: `admin/media/${accountId}/groups/${deleteId}`,
    }).then(() => {
      fetchGroups();
      setIsShowModal(false);
    });
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
  
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell>{row.id}</TableCell>
          <TableCell>{row.priority}</TableCell>
          <TableCell>{row.name}</TableCell>
          <TableCell>{row.desc}</TableCell>
          <TableCell className={classes.buttonCol}>
            <IconButton 
              color="primary" 
              aria-label="add an Edit"
              onClick={() => onClickEditButton(row.id)}
            >
              <Edit />
            </IconButton>
            <IconButton 
              className={classes.buttonRed} 
              aria-label="add an Delete"
              onClick={() => openDialog(row.id, row.deleted_at)}
            >
              <Delete />
            </IconButton>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                アカウント詳細
              </Typography>
              <Grid container>
                <Grid item xs={12} className={classes.wrapper}>
                  <Typography variant="inherit" className={classes.accountInfo}>
                    アカウントID
                  </Typography>
                  <Typography variant="inherit" >
                    {accountId}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.wrapper}>
                  <Typography variant="inherit" className={classes.accountInfo}>
                    アカウント名
                  </Typography>
                  <Typography variant="inherit" >
                    {accountName}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                収集グループ一覧
              </Typography>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>収集グループID</TableCell>
                    <TableCell>表示優先度</TableCell>
                    <TableCell>収集グループ名</TableCell>
                    <TableCell>概要</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {groups.map(
                    function (row, index) {
                      return <Row index={index+1} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
            {success && (
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="success"
                className={classes.alert}
              >
                {successMessage}
              </MuiAlert>
            )}
            <Grid container justifyContent="center" className={classes.wrapper}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => props.history.push(`/admin/media/accounts/group/${accountId}/create`)}
              >
                新規登録
              </Button>
            </Grid>
          </Grid>
          <Dialog open={isShowModal} onClose={() => setIsShowModal(false)}>
            <DialogContent>
              <DialogContentText>
                完全削除は10日後に行われますが、本当に削除してよろしいですか？
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={deleteGroup}>
                はい
              </Button>
              <Button color="primary" onClick={() => setIsShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }
    />
  );
}

export default withRouter(Groups);
